/* istanbul ignore file */
export const ErrorIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.99983 5.33314V7.99981M7.99983 10.6665H8.0065M6.85983 1.90648L1.21316 11.3331C1.09674 11.5348 1.03514 11.7633 1.03449 11.9962C1.03384 12.229 1.09416 12.4579 1.20945 12.6602C1.32474 12.8624 1.49098 13.031 1.69164 13.149C1.89229 13.2671 2.12036 13.3306 2.35316 13.3331H13.6465C13.8793 13.3306 14.1074 13.2671 14.308 13.149C14.5087 13.031 14.6749 12.8624 14.7902 12.6602C14.9055 12.4579 14.9658 12.229 14.9652 11.9962C14.9645 11.7633 14.9029 11.5348 14.7865 11.3331L9.13983 1.90648C9.02098 1.71055 8.85364 1.54856 8.65396 1.43613C8.45428 1.32371 8.22899 1.26465 7.99983 1.26465C7.77067 1.26465 7.54538 1.32371 7.3457 1.43613C7.14602 1.54856 6.97868 1.71055 6.85983 1.90648Z"
                stroke="#D92D20"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
